import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';

function ProductCard({ product }) {
  return (
    <div className="product-card">
      <div className="product-image-container">
        <img src={product.image} alt={product.name} className="product-image" />
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.shortDescription}</p>
        <div className="product-rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} />
            ))}
          </div>
          <span className="rating-text">(5.0)</span>
        </div>
        <p className="product-price">€{product.price.toFixed(2)}</p>
        <Link to={`/product/${product.id}`} className="view-details-btn">
          Visualizza Dettagli
        </Link>
      </div>
    </div>
  );
}

export default ProductCard;